import { defineMessages } from 'react-intl';

export default defineMessages({
    buildingAndLocationsTitle: {
        id: "change.wizard.commercial.TWIA.BuildingLoc",
        defaultMessage: "Buildings & Locations"
    },
    buildingAndLocationsCardTitle: {
        id: "change.wizard.commercial.TWIA.Add buildings and locations by entering their details.",
        defaultMessage: "Add buildings and locations by entering their details."
    },
    addBuilding: {
        id: "change.wizard.commercial.TWIA.Add Building",
        defaultMessage: "Add Building"
    },
    cancelButton: {
        id: "change.wizard.commercial.TWIA.Cancel",
        defaultMessage: "Cancel"
    },
    nextButton: {
        id: "change.wizard.commercial.TWIA.Next",
        defaultMessage: "Next"
    },
    anotherButton: {
        id: "change.wizard.commercial.TWIA.anotherBuilding",
        defaultMessage: "Add Another Building"
    },
    doneButton: {
        id: "change.wizard.commercial.TWIA.Done",
        defaultMessage: "Done"
    },
    locationStep: {
        id: "change.wizard.commercial.TWIA.Location",
        defaultMessage: "Location"
    },
    buildingStep: {
        id: "change.wizard.commercial.TWIA.BuildingStep",
        defaultMessage: "Building"
    },
    constructionStep: {
        id: "change.wizard.commercial.TWIA.Construction",
        defaultMessage: "Construction"
    },
    coveragesStep: {
        id: "change.wizard.commercial.TWIA.Coverages",
        defaultMessage: "Coverages"
    },
    additionalInterestsStep: {
        id: "change.wizard.commercial.TWIA.Additional Interests",
        defaultMessage: "Additional Interests"
    },
    cancelModalTitle: {
        id: "change.wizard.commercial.TWIA.Cancel Adding Building?",
        defaultMessage: "Cancel Adding Building?"
    },
    cancelModalDescription: {
        id: "change.wizard.commercial.TWIA.The information you have already provided about this building will be lost",
        defaultMessage: "The information you have already provided about this building will be lost. Are you sure you want to cancel?"
    },
    previousModalTitle: {
        id: "change.wizard.commercial.TWIA.Leave Page?",
        defaultMessage: "Leave Page?"
    },
    previousModalDescription: {
        id: "change.wizard.commercial.TWIA.Changes made to the building will be lost. ",
        defaultMessage: "Changes made to the building will be lost."
    },
    editLocation: {
        id: "change.wizard.commercial.editLocation",
        defaultMessage: "Edit Location"
    },
    editBuilding: {
        id: "change.wizard.commercial.editBuilding",
        defaultMessage: "Edit Building"
    },
    editConstruction: {
        id: "change.wizard.commercial.editConstruction",
        defaultMessage: "Edit Construction"
    },
    editCoverages: {
        id: "change.wizard.commercial.editCoverages",
        defaultMessage: "Edit Coverages"
    },
    editAddlInt: {
        id: "change.wizard.commercial.editAddlInt",
        defaultMessage: "Edit Additional Interest"
    },
    BCCovLimitAndBCRCV: {
        id: "twia.change.cp.views.building.BCCovLimitAndBCRCV information banner",
        defaultMessage: "The amount of insurance on Building Coverage {text} the minimum requirement for replacement cost coverage."
    },
    BPCovLimitAndBPRCV: {
        id: "twia.change.cp.views.building.BPCovLimitAndBPRCV information banner",
        defaultMessage: "The amount of insurance on Business Personal Property Coverage {text} the minimum requirement for replacement cost coverage."
    }
})